import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderOverlayComponent } from './loader-overlay/loader-overlay.component';
import { StoreModule } from '@ngrx/store';
import { layoutFeatureKey, layoutReducer } from './state/layout.reducer';
import { EffectsModule } from '@ngrx/effects';
import { LayoutEffects } from './state/layout.effects';
import { NavbarComponent } from './navbar/navbar.component';

@NgModule({
  declarations: [LoaderOverlayComponent, NavbarComponent],
  imports: [CommonModule, StoreModule.forFeature(layoutFeatureKey, layoutReducer), EffectsModule.forFeature([LayoutEffects])],
  exports: [LoaderOverlayComponent, NavbarComponent],
})
export class LayoutModule {}
